import type { RouteConfig } from 'vue-router';

const PassThrough = () => import('@/views/PassThrough.vue');
const CreditNotesList = () => import('@/pages/customers/credit-notes/CreditNotesList.vue');

const creditNotesRoutes: Array<RouteConfig> = [
  {
    path: 'credit-notes-new/:group?',
    name: 'credit-notes-new',
    redirect: (to) => ({ path: `/v3/customers/credit-notes/${to.params.group ?? ''}` }),
  },
  {
    path: 'credit-note-new/:uuid?',
    name: 'credit-note-new',
    props: true,
    redirect: (to) => ({ path: `/v3/customers/credit-notes/credit-note/${to.params.uuid ?? ''}` }),
  },
  {
    path: 'templates/credit-notes-new',
    name: 'template-credit-notes-new',
    redirect: { path: '/v3/customers/templates/credit-notes' },
  },
  {
    path: 'templates/credit-note-new/:uuid?',
    name: 'template-credit-note-new',
    props: true,
    redirect: (to) => ({ path: `/v3/customers/templates/credit-notes/credit-note/${to.params.uuid ?? ''}` }),
  },
  {
    path: 'credit-notes',
    component: PassThrough,
    alias: ['credit_note'],
    children: [
      {
        path: ':group?',
        name: 'credit-notes-list',
        meta: {
          title: 'credit_notes',
        },
        component: CreditNotesList,
        beforeEnter(to, _, next) {
          if (!to.params.group) {
            next({ name: 'credit-notes-list', params: { group: 'open' } });
          } else {
            next();
          }
        },
      },
    ],
  },
];

export default creditNotesRoutes;
